var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Notice"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Glyph"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.4667 12.9925C16.2101 12.8646 15.9274 12.7981 15.6407 12.7981C15.3541 12.7981 15.0714 12.8646 14.8148 12.9925C13.7977 13.5253 12.6667 13.8036 11.5185 13.8036C10.3704 13.8036 9.23929 13.5253 8.22222 12.9925C7.96567 12.8646 7.68294 12.7981 7.3963 12.7981C7.10965 12.7981 6.82692 12.8646 6.57037 12.9925C5.50343 13.5088 4.60302 14.3145 3.97175 15.3177C3.34049 16.3209 3.00378 17.4813 3 18.6666V20.148C3 20.6392 3.19511 21.1102 3.54239 21.4575C3.88968 21.8048 4.36071 21.9999 4.85185 21.9999H18.1852C18.6763 21.9999 19.1474 21.8048 19.4946 21.4575C19.8419 21.1102 20.037 20.6392 20.037 20.148V18.6666C20.0333 17.4813 19.6965 16.3209 19.0653 15.3177C18.434 14.3145 17.5336 13.5088 16.4667 12.9925Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.5185 11.6296C14.1777 11.6296 16.3334 9.47396 16.3334 6.81482C16.3334 4.15567 14.1777 2 11.5185 2C8.8594 2 6.70374 4.15567 6.70374 6.81482C6.70374 9.47396 8.8594 11.6296 11.5185 11.6296Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.3794e5284d0d24116c0c18896908bb25.svg";
export { ForwardRef as ReactComponent };